export default __webpack_public_path__ + "static/media/RTMP_ADD2.bdb2c501.png";